import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faSave,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import api from "../../services/client/api";
import { StepContainer, ModalWrapper, StepTexth4 } from "./styles";
import { Label, Button, Alert, Spinner, Fade } from "reactstrap";

const Desfecho = ({
  token,
  username,
  onClose,
  report,
  refreshReports,
  action,
}) => {
  const [desfechos, setDesfechos] = useState([]);
  const [dataDesfecho, setDataDesfecho] = useState("");
  const [selectedDesfecho, setSelectedDesfecho] = useState(null);
  const [alertInsert, setAlertInsert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchDesfecho = async () => {
      try {
        const response = await api().user().getDesfecho(token);

        if (response.status === 200) {
          const ordered = response.output.sort((a, b) => a.Ordem - b.Ordem);
          setDesfechos(ordered);
        }
      } catch (err) {
        console.error("Erro ao buscar desfechos:", err);
      }
    };

    fetchDesfecho();
  }, [token]);

  useEffect(() => {
    if (report) {
      if (report.CodDesfecho != null) {
        setSelectedDesfecho(Number(report.CodDesfecho));
      }

      if (report.DtaDesfecho) {
        // usa a data vinda da API
        const formattedDate = new Date(report.DtaDesfecho)
          .toISOString()
          .split("T")[0];

        setDataDesfecho(formattedDate);
      } else {
        // usa a data atual
        const today = new Date().toISOString().split("T")[0];
        setDataDesfecho(today);
      }
    }
  }, [report]);

  const handleSave = async () => {
    if (!selectedDesfecho) {
      setErrorMessage("Selecione um desfecho.");
      return;
    }

    if (!dataDesfecho) {
      setErrorMessage("Informe a data do desfecho.");
      return;
    }

    setErrorMessage("");

    try {
      const payload = {
        CodDesfecho: selectedDesfecho,
        DtaDesfecho: dataDesfecho,
        CodRequisicao: report.CodRequisicao,
        username: username,
      };

      const response = await api().user().insertDesfecho(token, payload);

      if (response.status === 201) {
        setAlertInsert(true);

        setTimeout(() => {
          onClose();
          refreshReports();
        }, 2000);
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  };

  const handleUpdate = async () => {
    if (!selectedDesfecho) {
      setErrorMessage("Selecione um desfecho.");
      return;
    }

    if (!dataDesfecho) {
      setErrorMessage("Informe a data do desfecho.");
      return;
    }

    setErrorMessage("");

    try {
      const payload = {
        CodDesfecho: selectedDesfecho,
        DtaDesfecho: dataDesfecho,
        CodRequisicao: report.CodRequisicao,
        username: username,
      };

      const response = await api().user().updateDesfecho(token, payload);

      if (response.status === 200) {
        setAlertInsert(true);

        setTimeout(() => {
          onClose();
          refreshReports();
        }, 2000);
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  };

  return (
    <ModalWrapper>
      {alertInsert ? (
        <>
          <Fade>
            <Alert
              color="success"
              style={{ textAlign: "center", marginTop: 40 }}
            >
              <b>
                Desfecho salvo com sucesso{" "}
                <FontAwesomeIcon icon={faCheck} />{" "}
              </b>
              <br /> Retornando para a listagem <Spinner size="sm"></Spinner>
            </Alert>
          </Fade>
        </>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={onClose}
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                border: "none",
                background: "#0C2B6E",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </button>
          </div>
          <StepContainer>
            <StepTexth4 style={{ marginTop: 25 }}>
              <b>Defina o desfecho:</b>
            </StepTexth4>
          </StepContainer>

          {errorMessage && (
            <Alert color="danger" style={{ textAlign: "center" }}>
              <b>{errorMessage}</b>
            </Alert>
          )}

          <StepContainer
            style={{
              marginTop: 20,
              display: "flex",
              gap: 15,
              justifyContent: "center",
            }}
          >
            {/* Campo Desfecho */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "40%",
                borderRadius: "10px",
                backgroundColor: "#cacaca",
                padding: "9px",
              }}
            >
              <Label>
                <b>Desfecho:</b>
              </Label>
              <select
                value={selectedDesfecho ?? ""}
                onChange={(e) => setSelectedDesfecho(Number(e.target.value))}
                style={{
                  width: "100%",
                  padding: "8px 5px", // Aumenta altura
                  minHeight: "38px", // Garante altura mínima igual ao input
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="">Selecione...</option>
                {desfechos.map((item) => (
                  <option key={item.CodDesfecho} value={item.CodDesfecho}>
                    {item.Desfecho}
                  </option>
                ))}
              </select>
            </div>

            {/* Campo Data */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "40%",
                borderRadius: "10px",
                backgroundColor: "#cacaca",
                padding: "9px",
              }}
            >
              <Label>
                {" "}
                <b> Data Desfecho:</b>
              </Label>
              <input
                type="date"
                value={dataDesfecho}
                onChange={(e) => setDataDesfecho(e.target.value)}
                style={{
                  width: "100%",
                  padding: "5px",
                  height: "38px", // Mesma altura que o select
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
          </StepContainer>

          <StepContainer style={{ marginTop: 20, display: "flex" }}>
            <Button
              color="primary"
              size="md"
              onClick={() => {
                if (action === "insert") {
                  handleSave();
                } else if (action === "update") {
                  handleUpdate();
                }
              }}
            >
              <b>
                {action === "insert" ? "Salvar Desfecho" : "Atualizar Desfecho"}
              </b>
              <FontAwesomeIcon style={{ marginLeft: 5 }} icon={faSave} />
            </Button>
          </StepContainer>
        </>
      )}
    </ModalWrapper>
  );
};

export default Desfecho;
